import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import App from 'components/App';
import { apolloClient } from './apollo';
var app = (React.createElement(ApolloProvider, { client: apolloClient },
    React.createElement(BrowserRouter, null,
        React.createElement(App, null))));
var root = document.getElementById('app-root');
ReactDOM.hydrate(app, root);
